import { Link } from "react-router-dom";
import siteConfig, { getCopyrightText } from "../../config/site";

export const Footer = () => {
  return (
    <footer className="bg-black text-white">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src="/images/exo-logo-nav.png"
              alt="Exo Entertainment"
              className="h-10 w-auto mb-3 opacity-80"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Premium private entertainment experiences in Calgary, AB. 
              Persona-driven performers. Curated shows. Complete discretion.
            </p>
            <p className="text-gray-500 text-sm">
              📍 Calgary, AB, Canada
            </p>
            <a
              href="mailto:booking@exoentertainment.ca"
              className="text-gold hover:text-gold-light text-sm transition-colors block mt-1"
            >
              ✉️ booking@exoentertainment.ca
            </a>
          </div>

          {/* Navigate */}
          <div>
            <h4 className="text-gold font-semibold text-xs uppercase tracking-[0.2em] mb-4">Navigate</h4>
            <ul className="space-y-2">
              {[
                { to: "/about", label: "About" },
                { to: "/services", label: "Services" },
                { to: "/entertainers", label: "Entertainers" },
                { to: "/book", label: "Book Now" },
                { to: "/calgary", label: "Calgary" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-gold font-semibold text-xs uppercase tracking-[0.2em] mb-4">Company</h4>
            <ul className="space-y-2">
              {[
                { to: "/hiring", label: "Join Our Team" },
                { to: "/privacy", label: "Privacy Policy" },
                { to: "/terms", label: "Terms of Service" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-gold font-semibold text-xs uppercase tracking-[0.2em] mb-4">Connect</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="mailto:booking@exoentertainment.ca"
                  className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                >
                  Email Us
                </a>
              </li>
              {siteConfig.social.instagram && (
                <li>
                  <a
                    href={siteConfig.social.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    Instagram
                  </a>
                </li>
              )}
            </ul>
            <div className="mt-6">
              <Link
                to="/book"
                className="inline-block px-6 py-2 bg-gold text-black font-bold text-sm rounded-full hover:bg-gold-light transition-all duration-300"
              >
                Book Now
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800/50">
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs">
            {getCopyrightText()}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-gray-600 text-xs border border-gray-700 rounded-full px-3 py-1">
              🔞 18+ Only
            </span>
            <span className="text-gray-600 text-xs">
              Calgary, AB
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
